/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Chat_Tool_Confirm_Credential_SourceInputs */



/**
* | output |
* | --- |
* | "Using: {label}" |
*
* @param {Chat_Tool_Confirm_Credential_SourceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_credential_source = /** @type {((inputs: Chat_Tool_Confirm_Credential_SourceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Credential_SourceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verwendet: ${i?.label}`)
	return /** @type {LocalizedString} */ (`Using: ${i?.label}`)
});